<span *ngIf="requestCount && requestCount>0" class="d-inline-block eod-text-danger"> 
   Requested {{ requestCount }}
</span>

<span *ngIf="requestCount && requestCount>0" class="d-inline-block text-logo-blue cursor-pointer text-underline lH-12 ml-3" > 
   Grant Access
</span>
